import { Injectable, Pipe } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContactModel } from '../models/contact.model';
// tslint:disable-next-line:use-pipe-transform-interface
@Pipe({ name: 'ContactService' })

@Injectable()
export class ContactService {

    constructor(private httpClient: HttpClient) { }

  createContact(contact: ContactModel, userId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/contact/create';
    return this.httpClient.post(url, { Contact: contact, UserId: userId })
      .map((response: Response) => {
        return response;
      });
    }

  getContactById(contactId: string, userId: string) {
      const url = localStorage.getItem('ApiEndPoint') + '/api/contact/getContactById';
    return this.httpClient.post(url, { ContactId: contactId, UserId: userId })
      .map((response: Response) => {
        return response;
      });
  }

  editContactById(contact: ContactModel, userId: string) {
      const url = localStorage.getItem('ApiEndPoint') + '/api/contact/editContactById';
    return this.httpClient.post(url, { Contact: contact, UserId: userId })
      .map((response: Response) => {
        return response;
      });
  }

  deleteContactById(contactId: string, userId: string) {
      const url = localStorage.getItem('ApiEndPoint') + '/api/contact/deleteContactById';
      return this.httpClient.post(url, { ContactId: contactId, UserId: userId })
      .map((response: Response) => {
        return response;
      });
  }

  getAllCountry(userId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/country/getAllCountry';
    return this.httpClient.post(url, {  UserId: userId })
    .map((response: Response) => {
      return response;
    });
}

  //getAllContactByObjectType(objectType: string) {
  //  const currentUser = <any>sessionStorage.getItem('auth');
  //  const headers = new Headers({
  //    'Authorization': 'Bearer ' + JSON.parse(currentUser).token
  //  });
  //  const options = new RequestOptions({ headers: headers });
  //  const url = localStorage.getItem('ApiEndPoint') + '/api/contact/getAllContactByObjectType';
  //  return this.http.post(url, { ObjectType: objectType, UserId: JSON.parse(currentUser).UserId }, options)
  //    .map((response: Response) => {
  //      return response.json();
  //    });
  //}

  //searchContact(contact: ContactModel, lead: LeadModel) {
  //  const currentUser = <any>sessionStorage.getItem('auth');
  //  const headers = new Headers({
  //    'Authorization': 'Bearer ' + JSON.parse(currentUser).token
  //  });
  //  const options = new RequestOptions({ headers: headers });
  //  const url = localStorage.getItem('ApiEndPoint') + '/api/contact/searchContact';
  //  return this.http.post(url, {
  //    FirstName: contact.FirstName,
  //    LastName: contact.LastName,
  //    Phone: contact.Phone,
  //    Email: contact.Email,
  //    PotentialId: lead.PotentialId,
  //    StatusId: lead.StatusId,
  //    InterestedGroupId: lead.InterestedGroupId,
  //    PersonInChargeId: lead.PersonInChargeId,
  //    UserId: JSON.parse(currentUser).UserId
  //  }, options)
  //    .map((response: Response) => {
  //      return response.json();
  //    });
  //}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/contact.service.ts